<template>
  <div class="w-main">
    <div class="w-header flex">
      <div class="info">
        <el-image style="width: 50px; height: 50px;margin-right: 20px;" :src="logo" fit="fill"></el-image>
        <span>官网装修</span>
      </div>
      <el-row class="operate">
        <el-button type="primary" @click="handleSave">保存</el-button>
        <!-- <el-button type="primary" @click="handleRelease">发布</el-button> -->
      </el-row>
    </div>
    <div class="w-content">
      <div class="w-left">
        <p class="w-title">模块组件</p>
        <div class="w-module">
          <template  v-for="item in moduleList">
            <div class="module" v-if="item.showType.indexOf(tenantType) > -1" @click="addModule(item)">
                <el-image style="width: 32px; height: 32px" :src="item.moduleIcon"></el-image>
                <span class="module-name">{{item.moduleName}}</span>
            </div>
          </template>
        </div>
        <p class="w-title">基本组件</p>
        <div class="w-module">
          <div class="module" v-for="item in baseList" @click="addModule(item)">
            <el-image style="width: 32px; height: 32px" :src="item.moduleIcon"></el-image>
            <span class="module-name" v-if="item.moduleCode === 102">图片</span>
            <span class="module-name" v-else-if="item.moduleCode === 104">视频</span>
            <span class="module-name" v-else>{{item.moduleName}}</span>
          </div>
        </div>
      </div>
      <!-- 手机端展示效果 -->
      <div class="w-center" id="dialogue_box">
        <div class="phone-box-w">
          <div class="phone-box-header">
            <el-image style="width: 100%; height: 65px" :src="phoneHeader"></el-image>
          </div>
          <div class="phone-box-inner">
            <template v-for="(item,index) in appInfos">
              <div class="module-item" :key="index" @click="selectModule(item)">
                <div class="shadow" v-if="item.showShadow"></div>
                <div class="ope-btns">
                  <i class="el-icon-top" v-if="index !== 0" @click.stop="goUp(index)"></i>
                  <i class="el-icon-bottom" v-if="index < appInfos.length-1" @click.stop="goDown(index)"></i>
                  <i class="el-icon-close" @click.stop="goDel(index)"></i>
                </div>
                <!-- 企业名称模块 -->
                <div class="website service-website" v-if="item.moduleCode === 17">
                  <div style="padding: 6px 0 3px 0">
                    <el-avatar shape="square" size="large" :src="item.content.companyLogo"></el-avatar>
                    <span class="companyName">{{ item.content.companyName }}</span>
                    <img class="company-gsxx" src="@/assets/website/company-gsxx.png"/>
                  </div>
                </div>
                <!-- 知识产权 -->
                <div class="website service-website" v-if="item.moduleCode === 14">
                  <div class="module-title">
                    <el-image class="title-icon" :src="item.moduleIcon"></el-image>
                    <span class="title-name">{{item.moduleName}}</span>
                  </div>
                  <div class="knowledge-info">
                     <img class="knowledge-icon" src="@/assets/website/trademark-icon.png"/>
                    <div class="info-count">{{item.content.tradeMarkCount}}</div>
                    <div class="info-name">商标信息</div>
                  </div>
                  <div class="knowledge-info">
                    <img class="knowledge-icon" src="@/assets/website/patent-icon.png"/>
                    <div class="info-count">{{item.content.patentCount}}</div>
                    <div class="info-name">专利信息</div>
                  </div>
                  <div class="knowledge-info">
                    <img class="knowledge-icon" src="@/assets/website/certificate-icon.png"/>
                    <div class="info-count">{{item.content.certificateCount}}</div>
                    <div class="info-name">资质证书</div>
                  </div>
                </div>
                <!-- 咨询模块 -->
                <div class="website service-website" v-if="item.moduleCode === 'service'">
                  <el-image class="title-icon" :src="item.moduleIcon"></el-image>
                </div>
                <!-- 标题模块 -->
                <div class="website" v-if="item.moduleCode === 100">
                  <div class="module-title">
                    <el-image class="title-icon" :src="item.moduleIcon"></el-image>
                    <span class="title-name">{{item.moduleName}}</span>
                  </div>
                </div>
                <!-- 文本模块 -->
                <div class="website" v-else-if="item.moduleCode === 101">
                  <div class="text-box" :style="{'text-align':item.textAlign}">
                    <h3
                      class="h3"
                    >{{item.content.mainTitle}}</h3>
                    <h4
                      class="h4"
                    >{{item.content.subTitle}}</h4>
                    <p class="p">{{item.content.textContent}}</p>
                  </div>
                </div>
                <!-- 基础图片，模块图片 模块 -->
                <div class="website img-website" v-else-if="item.moduleCode === 102 || item.moduleCode === 11">
                  <div class="module-title" v-if="item.moduleCode === 11 && item.moduleName" style="padding: 0 15px;margin-bottom:-10px;">
                    <el-image class="title-icon" :src="item.moduleIcon"></el-image>
                    <span class="title-name">{{item.moduleName}}</span>
                  </div>
                  <div class="img-box">
                    <!-- <div class="single-img" v-if="item.imgLength === 1"></div> -->
                    <div :class="item.content.picStyle == 1? 'slide-img pic horizontal' : 'slide-img pic vertical'" v-if="item.content.picUrlList.length === 0">
                      <span class="img"></span>
                      <span class="img"></span>
                      <span class="img"></span>
                    </div>
                    <div :class="item.content.picStyle == 1? 'slide-img pic horizontal' : 'slide-img pic vertical'" v-else>
                      <span class="img" v-for="img in item.content.picUrlList">
                        <el-image
                          class="title-icon"
                          style="width:100%;height:100%;"
                          :src="img"
                          fit="contain"
                        ></el-image>
                      </span>
                      <span class="img"></span>
                    </div>
                  </div>
                </div>
                <!-- 轮播图模块 -->
                <div class="website slide-website" v-else-if="item.moduleCode === 103">
                  <div class="type-1">
                    <template v-if="item.content.length > 0">
                      <template>
                        <el-carousel height="134px" :autoplay="false">
                          <el-carousel-item v-for="(i,index) in item.content" :key="index">
                            <el-image
                              class="title-icon"
                              style="width:100%;height:100%;"
                              :src="i.picUrl"
                              fit="cover"
                            >
                              <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                              </div>
                            </el-image>
                          </el-carousel-item>
                        </el-carousel>
                      </template>
                      <!-- <template v-else>
                        <span class="img"></span>
                      </template> -->
                    </template>
                    <template v-else>
                      <span class="img"></span>
                    </template>
                  </div>
                </div>
                <!-- 基础视频，模块视频 模块 -->
                <div class="website video-website" v-else-if="item.moduleCode === 104 || item.moduleCode === 12">
                  <div class="module-title" v-if="item.moduleCode === 12 && item.moduleName">
                    <el-image class="title-icon" :src="item.moduleIcon"></el-image>
                    <span class="title-name">{{item.moduleName}}</span>
                  </div>
                  <div class="video-box">
                    <div class="video" v-if="!item.content.coverPicUrl"></div>
                    <template v-else>
                        <el-image
                          class="title-icon video-bg"
                          style="width:100%;height:100%;"
                          :src="item.content.coverPicUrl"
                          fit="fill"
                        ></el-image>
                    </template>
                    <p class="p" v-if="item.content.title">{{item.content.title}}</p>
                  </div>
                </div>
                <!-- 关于我们模块 -->
                <div class="website video-website" v-else-if="item.moduleCode === 1">
                  <div class="module-title items-start">
                    <el-image class="title-icon" :src="item.moduleIcon"></el-image>
                    <span class="title-name">{{item.moduleName}}</span>
                  </div>
                  <div class="video-box">
                    <div class="video none-video" v-if="item.content.picUrl == ''">
                    </div>
                    <template class="video" v-else>
                      <div>
                        <el-image
                          class="title-icon"
                          :src="item.content.picUrl"
                          fit="cover"
                        ></el-image>
                      </div>
                    </template>
                    <p class="p" style="font-weight: 400;">{{item.content.introduction}}</p>
                  </div>
                </div>
                <!-- 3-企业文章 15-技术文章 16-招标信息 模块 -->
                <div class="website about-website" v-if="item.moduleCode === 3 || item.moduleCode === 15 || item.moduleCode === 16">
                  <div class="module-title items-start">
                    <el-image class="title-icon" :src="item.moduleIcon"></el-image>
                    <span class="title-name">{{item.moduleName}}</span>
                  </div>
                  <div class="no-data" v-if="item.content.length === 0">从右侧设置栏添加文章</div>
                  <template v-else>
                    <div class="text-box article-box flex" v-for="article in item.content">
                      <!-- 列表排版  1-左标题右图 2-上标题下1图 3-上标题下3图 4-仅标题 -->
                      <!-- 暂时只处理 2种格式 以后有时间再优化 -->
                      <div class="content-box"
                           v-if="article.listStyle === 1 || article.listStyle === 2 || article.listStyle === 3">
                        <p class="article-title">{{ article.title }}</p>
                        <div class="article-info" style="color: #333;margin-top:10px;">
                          <div style="color:#666;">
                            <span>{{ article.appShowPublishTimeStr }}</span>
                            <span style="margin-left: 10px">{{ article.readCount }}浏览</span>
                          </div>
                          <div style="color:#666; margin-top: 5px">
                            {{ article.tenantName }}
                          </div>
                        </div>
                      </div>
                      <div class="header-img-box" style="margin-left: 15px"
                           v-if="article.listStyle === 1 || article.listStyle === 2 || article.listStyle === 3">
                        <el-image
                          class="title-icon"
                          style="width:94px;height:74px;"
                          :src="article.headPicUrl"
                          fit="cover"
                        ></el-image>
                      </div>
                      <div v-if="article.listStyle === 4" style="line-height: 1">
                        <span class="article-only-title">{{ article.title }}</span>
                        <span style="font-size: 14px;margin-left: 18px">{{ article.appShowPublishTimeStr }}</span>
                      </div>
                    </div>
                  </template>
                </div>
                <!-- 合作伙伴模块 -->
                <div class="website about-website" v-if="item.moduleCode === 6">
                  <div class="module-title items-start">
                    <el-image class="title-icon" :src="item.moduleIcon"></el-image>
                    <span class="title-name">{{ item.moduleName }}</span>
                  </div>
                  <div class="img-content">
                    <div class="img-list">
                      <span class="img-bg" v-for="img in item.content">
                        <el-image
                          class="title-icon"
                          style="width:94px;height:45px;"
                          :src="img"
                          fit="fill"
                        ></el-image>
                      </span>
                      <span class="img-bg" v-if="(item.content && item.content.length < 1) || !item.content"></span>
                    </div>
                  </div>
                </div>
                <!-- 入驻组织模块 -->
                <div class="website about-website" v-if="item.moduleCode === 9">
                  <div class="module-title items-start">
                    <el-image class="title-icon" :src="item.moduleIcon"></el-image>
                    <span class="title-name">{{item.moduleName}}</span>
                  </div>
                  <div class="content-box">
                    <div class="text-box article-box flex" v-for="group in item.content">
                      <div class="header-img-box">
                        <el-image
                          class="title-icon"
                          style="width:60px;height:60px;"
                          :src="group.companyLogo"
                          fit="fill"
                        ></el-image>
                      </div>
                      <div class="content-box">
                        <p class="article-title">{{group.fullName}}</p>
                        <div class="article-info" style="color: #333;margin-top:10px">
                          企业{{group.memberCount}}家
                        </div>
                      </div>
                      <el-button round size="mini" class="home-btn">主页</el-button>
                    </div>
                  </div>
                </div>
                <!-- 组织成员模块 -->
                <div class="website about-website" v-if="item.moduleCode === 13">
                  <div class="module-title items-start">
                    <el-image class="title-icon" :src="item.moduleIcon"></el-image>
                    <span class="title-name">{{item.moduleName}}</span>
                  </div>
                  <div class="groupMemberContent">
                    <template v-for="(member, index) in item.content.rows">
                      <div class="groupMember" v-if="index < memberToggleNum">
                        <el-image class="groupMemberLogo" :src="member.companyLogo"></el-image>
                        <div class="groupMemberName">{{member.tenantFullName}}</div>
                      </div>
                      <div class="groupMember" v-show="item.openFlag && index >= memberToggleNum">
                        <el-image class="groupMemberLogo" :src="member.companyLogo"></el-image>
                        <div class="groupMemberName">{{member.tenantFullName}}</div>
                      </div>
                    </template>
                  </div>
                  <div v-show="!item.openFlag && item.content.rows.length > memberToggleNum" class="memberToggle" @click="handleMemberToggle(item,1)">
                    展开 <i class="el-icon-d-arrow-right" style="transform: rotate(90deg)"></i>
                  </div>
                  <div v-show="item.openFlag" class="memberToggle" @click="handleMemberToggle(item,0)">
                    收起 <i class="el-icon-d-arrow-right" style="transform: rotate(-90deg)"></i>
                  </div>
                </div>
                <!-- 分类模块 分类模块已下掉-->
                <div class="website about-website" v-if="false">
                  <div class="module-title items-start">
                    <el-image class="title-icon" :src="item.moduleIcon"></el-image>
                    <span class="title-name">{{item.moduleName}}</span>
                  </div>
                  <div >
                    <el-button round size="mini" style="margin:0 5px 10px 0" v-for="tag in item.content">{{tag}}</el-button>
                  </div>
                </div>
                <!-- 管理团队模块 -->
                <div class="website about-website" v-if="item.moduleCode === 7">
                  <div class="module-title items-start">
                    <el-image class="title-icon" :src="item.moduleIcon"></el-image>
                    <span class="title-name">{{item.moduleName}}</span>
                  </div>
                  <div class="manage-content">
                    <div class="manage-list" v-if="item.content.length === 0">
                      <span class="header-bg"></span>
                      <div class="text">
                        <div class="title">名字</div>
                        <div class="sub-title">职位</div>
                        <div class="intro">介绍</div>
                      </div>
                    </div>
                    <template v-else>
                      <div class="manage-list" v-for="manage in item.content">
                        <span class="header-bg">
                          <el-image
                            class="title-icon"
                            style="width:80px;height:80px;"
                            :src="manage.avatar"
                            fit="fill"
                            v-if="manage.avatar"
                          >
                            <span slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"/>
                            </span>
                          </el-image>
                          <span v-else class="default-header"></span>
                        </span>
                        <div class="text">
                          <div class="title">{{manage.userName}}</div>
                          <div class="sub-title">{{manage.postName || '暂无'}}</div>
                          <div class="intro">{{manage.userIntroduction}}</div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
                <!-- 联系我们模块 -->
                <div class="website about-website" v-if="item.moduleCode === 5">
                  <div class="module-title items-start">
                    <el-image class="title-icon" :src="item.moduleIcon"></el-image>
                    <span class="title-name">{{item.moduleName}}</span>
                  </div>
                  <div class="contact-content" v-if="item.content.linkUserName || item.content.linkPhoneNumber">
                    <i class="el-icon-phone-outline label-icon"></i>
                    <div class="label-content">
                      <div class="label-title">{{item.content.linkUserName ? item.content.linkUserName : '联系电话'}}</div>
                      <div class="label-info">{{item.content.linkPhoneNumber}}</div>
                    </div>
                  </div>
                  <div class="contact-content" v-if="item.content.linkAddress">
                    <i class="el-icon-map-location label-icon"></i>
                    <div class="label-content">
                      <div class="label-title">联系地址</div>
                      <div class="label-info">{{item.content.linkAddress}}</div>
                    </div>
                  </div>
                </div>
                <!-- 案例，产品模块 -->
                <div class="website about-website" v-if="item.moduleCode === 4 || item.moduleCode === 2">
                  <div class="module-title items-start">
                    <el-image class="title-icon" :src="item.moduleIcon"></el-image>
                    <span class="title-name">{{item.moduleName}}</span>
                  </div>
                  <div class="img-box">
                    <div class="slide-img" v-if="item.content.length === 0">
                      <span class="img"></span>
                      <span class="img"></span>
                      <span class="img"></span>
                    </div>
                    <div class="slide-img" v-else>
                      <span class="img" v-for="product in item.content">
                        <el-image
                          class="title-icon"
                          style="width:100%;height:100%;"
                          :src="product.headPicUrl"
                          fit="cover"
                        ></el-image>
                      </span>
                      <span class="img"></span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <!-- 右侧配置 -->
      <div class="w-right">
        <p class="set-title">{{setTitle}}</p>
        <div class="form-box">
          <!-- 官网名称 -->
          <el-form
            v-if="form.moduleCode === 17"
            v-model="form"
            ref="form"
            label-width="115px"
            label-position="left"
          >
          </el-form>
          <!-- 标题模块 -->
          <el-form
            v-if="form.moduleCode === 100"
            v-model="form"
            ref="form"
            label-width="115px"
            label-position="left"
          >
            <el-form-item label="组件标题：">
              <el-input v-model="form.moduleName" maxlength="15" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="选择图标：">
              <div class="title-icon-box">
                <span
                  v-for="(icon,index) in titleIcon"
                  :key="index"
                  :class="form.moduleIcon === icon.url ? 'current icon-box' : 'icon-box'"
                  @click="iconSelect(icon)"
                >
                  <el-image style="width: 24px; height: 24px" :src="icon.url"></el-image>
                </span>
              </div>
            </el-form-item>
          </el-form>
          <!-- 文本模块 -->
          <el-form
            v-else-if="form.moduleCode === 101"
            v-model="form"
            ref="form"
            label-width="115px"
            label-position="left"
          >
            <el-form-item label="内容设置：">
              <el-checkbox-group v-model="form.titleShow">
                <el-checkbox label="showTitle">主标题</el-checkbox>
                <el-checkbox label="showSubTitle">副标题</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="文字位置：">
              <el-radio-group v-model="form.content.textPosition">
                <el-radio :label="1">左侧对齐</el-radio>
                <el-radio :label="2">水平居中</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="主标题："
              v-show="form.titleShow && form.titleShow.indexOf('showTitle') > -1"
            >
              <el-input v-model="form.content.mainTitle" maxlength="15" show-word-limit></el-input>
            </el-form-item>
            <el-form-item
              label="副标题："
              v-show="form.titleShow && form.titleShow.indexOf('showSubTitle') > -1"
            >
              <el-input v-model="form.content.subTitle" maxlength="15" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="内容：">
              <el-input
                v-model="form.content.textContent"
                type="textarea"
                :rows="4"
                :maxlength="500"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-form>

          <!-- 图片模块 -->
          <el-form
            v-else-if="form.moduleCode === 102 || form.moduleCode === 11"
            v-model="form"
            ref="form"
            label-width="115px"
            label-position="left"
          >
            <el-form-item label="标题：" v-if="form.moduleCode === 11">
              <el-input v-model="form.moduleName" :maxlength="20" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="选择图标："  v-if="form.moduleCode === 11">
              <div class="title-icon-box">
                <span
                  v-for="(icon,index) in titleIcon"
                  :key="index"
                  :class="form.moduleIcon === icon.url ? 'current icon-box' : 'icon-box'"
                  @click="iconSelect(icon)"
                >
                  <el-image style="width: 24px; height: 24px" :src="icon.url"></el-image>
                </span>
              </div>
            </el-form-item>
            <el-form-item label="图片样式：">
              <el-radio-group v-model="form.content.picStyle">
                <el-radio :label="1">横版</el-radio>
                <el-radio :label="2">竖版</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- <P>样式选择(切换样式将导致当前的内容丢失)</P> -->
            <el-form-item label="图片编辑：">
              <FileUpload
                v-model="form.content.fileObjs"
                :limit="10"
                :multiple="true"
                :readOnly="false"
                 accept="image/gif,image/jpg,image/jpeg,image/png"
                @on-change="handleFileChangePic"
              ></FileUpload>
            </el-form-item>
          </el-form>
          <!-- 咨询模块 -->
          <el-form
            v-else-if="form.moduleCode === 'service'"
            v-model="form"
            ref="form"
            label-width="115px"
            label-position="left"
          >
            <!-- <P>样式选择(切换样式将导致当前的内容丢失)</P> -->
            <el-form-item label="绑定咨询人员：">
              <el-input placeholder="请输入内容" v-model="form.staffName">
                <template slot="append">
                  <el-button type="success" @click="">关联员工</el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
          <!-- 轮播图模块 -->
          <template v-else-if="form.moduleCode === 103">
            <!-- <span class="tips-text">请上传3：2的文章封面图片</span> -->
            <p class="tip">请上传宽、高比例为3比1的轮播图片，图片后缀格式支持jpg/png/bmp，最多可添加10张图片，按住内容可上下拖拽设置排序</p>
            <transition-group name="drag-list">
              <div class="carousel-box" v-for="(carousel,index) in form.content" :key="index" :draggable="true" @dragstart="dragstart(carousel, index)" @dragenter="dragenter(carousel, index)" @dragend="dragend(carousel, index)">
                <FileUploadHeader
                  style="width: 100px;height:100px;overflow:hidden;"
                  v-model="carousel.fileObjs"
                  :limit="1"
                  accept="image/gif,image/jpg,image/jpeg,image/png,image/bmp"
                  :readOnly="false"
                  :autoCropWidth="300" :autoCropHeight="100"
                  :fixedNumber="[300, 100]"
                  @on-change="handleFileChangeCarousel($event, index)"
                ></FileUploadHeader>
                <span class="jump-info">
                  页面跳转:{{carousel.name}}
                  <el-dropdown @command="dropdownClick($event, index)">
                    <span class="el-dropdown-link">
                      修改
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="product">产品</el-dropdown-item>
                      <el-dropdown-item command="case">案例</el-dropdown-item>
                      <el-dropdown-item command="none">不跳转</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </span>
                <i class="close-icon el-icon-circle-close" color="#ff6767" @click="delArticle(carousel, index)"/>
              </div>
            </transition-group>
            <el-button type="primary" @click="addPic">添加图片</el-button>
          </template>
          <!-- 视频模块 -->
          <el-form
            v-else-if="form.moduleCode === 104 || form.moduleCode === 12"
            v-model="form"
            ref="form"
            label-width="115px"
            label-position="left"
          >
            <el-form-item label="标题：" v-if="form.moduleCode === 12">
              <el-input v-model="form.moduleName" :maxlength="20" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="选择图标："  v-if="form.moduleCode === 12">
              <div class="title-icon-box">
                <span
                  v-for="(icon,index) in titleIcon"
                  :key="index"
                  :class="form.moduleIcon === icon.url ? 'current icon-box' : 'icon-box'"
                  @click="iconSelect(icon)"
                >
                  <el-image style="width: 24px; height: 24px" :src="icon.url"></el-image>
                </span>
              </div>
            </el-form-item>
            <el-form-item label="视频：">
              <FileUpload v-model="form.content.videoFileObjs" :limit="1" :readOnly="false" @on-change="handleFileChange($event, 'video')" accept=".mp4,.mov,.avi,.flv"></FileUpload>
            </el-form-item>
            <el-form-item label="视频封面：">
              <span class="tips-text">请上传3：2的封面图片</span>
              <FileUploadHeader
                v-model="form.content.fileObjs"
                :limit="1"
                :readOnly="false"
                accept="image/gif,image/jpg,image/jpeg,image/png"
                :autoCropWidth="300" :autoCropHeight="169"
                @on-change="handleFileChange($event, 'pic')"
              ></FileUploadHeader>
            </el-form-item>
            <el-form-item label="视频标题：">
              <el-input v-model="form.content.title" :maxlength="20" show-word-limit></el-input>
            </el-form-item>
          </el-form>
          <!-- 模块组件 -->
          <el-form
            v-if="form.moduleCode === 1 || form.moduleCode === 5 ||form.moduleCode === 2 ||form.moduleCode === 4
            ||form.moduleCode === 3 ||form.moduleCode === 7 || form.moduleCode === 6 || form.moduleCode === 9
            || form.moduleCode === 10 || form.moduleCode === 13 || form.moduleCode === 14
            || form.moduleCode === 15 || form.moduleCode === 16"
            v-model="form"
            ref="form"
            label-width="115px"
            label-position="left"
          >
            <el-form-item label="标题：">
              <el-input v-model="form.moduleName" :maxlength="20" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="选择图标：">
              <div class="title-icon-box">
                <span
                  v-for="(icon,index) in titleIcon"
                  :key="index"
                  :class="form.moduleIcon === icon.url ? 'current icon-box' : 'icon-box'"
                  @click="iconSelect(icon)"
                >
                  <el-image style="width: 24px; height: 24px" :src="icon.url"></el-image>
                </span>
              </div>
            </el-form-item>
            <!-- 关于我们 -->
            <template v-if="form.moduleCode === 1">
              <el-form-item label="图片：">
<!--                <span class="tips-text">请上传3：2的图片</span>-->
<!--                <FileUploadHeader-->
<!--                  v-model="form.content.fileObjs"-->
<!--                  :limit="1"-->
<!--                  :readOnly="false"-->
<!--                   accept="image/gif,image/jpg,image/jpeg,image/png"-->
<!--                   :autoCropWidth="300" :autoCropHeight="200"-->
<!--                  @on-change="handleFileChangeAbout"-->
<!--                ></FileUploadHeader>-->
                <FileUpload v-model="form.content.fileObjs" :limit="1"
                            accept="image/jpg,image/jpeg,image/png,image/gif,image/bmp"
                            :readOnly="false" @on-change="handleFileChangeAbout"></FileUpload>
              </el-form-item>
              <el-form-item label="文字介绍：">
                <el-input type="textarea" v-model="form.content.introduction" :maxlength="2000" autosize show-word-limit placeholder="请输入200字内文字"></el-input>
              </el-form-item>
            </template>
            <!-- 联系我们 -->
            <template v-if="form.moduleCode === 5">
              <el-form-item label="联系人：">
                <el-input v-model="form.content.linkUserName" :maxlength="20"></el-input>
              </el-form-item>
              <el-form-item label="联系电话：">
                <el-input v-model="form.content.linkPhoneNumber" :maxlength="20"></el-input>
              </el-form-item>
              <el-form-item label="联系地址：">
                <el-input v-model="form.content.linkAddress" :maxlength="200" show-word-limit></el-input>
              </el-form-item>
            </template>
            <!-- 案例 -->
            <template v-if="form.moduleCode === 4">
              <el-row class="operate" style="margin-bottom: 10px;">
                <el-button type="primary" @click="add(2, '添加案例', form.moduleCode)">添加案例</el-button>
              </el-row>
              <p class="tips-text">按住内容可上下拖拽设置排序</p>
              <el-table ref="singleTable" :data="form.content" style="width: 100%" row-class-name="draggable-btn">
                <el-table-column prop="title" label="内容标题"></el-table-column>
                <el-table-column label="封面图" width="140px">
                  <template slot-scope="scope">
                    <el-image style="width: 40px; height: 40px" :src="scope.row.headPicUrl" fit="contain"></el-image>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="120px">
                  <template slot-scope="scope">
                    <el-button type="text" @click="delArticle(scope.row, scope.$index)">移除</el-button>
                    <el-button type="text" @click="handleSee(scope.row, scope.$index)">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
            <!-- 产品 -->
            <template v-if="form.moduleCode === 2">
              <el-row class="operate" style="margin-bottom: 10px;">
                <el-button type="primary" @click="add(3, '添加产品', form.moduleCode)">添加产品</el-button>
              </el-row>
              <p class="tips-text">按住内容可上下拖拽设置排序</p>
              <el-table ref="singleTable" :data="form.content" style="width: 100%" row-class-name="draggable-btn">
                <el-table-column prop="title" label="内容标题"></el-table-column>
                <el-table-column label="封面图" width="140px">
                  <template slot-scope="scope">
                    <el-image style="width: 40px; height: 40px" :src="scope.row.headPicUrl" fit="contain"></el-image>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="120px">
                  <template slot-scope="scope">
                    <el-button type="text" @click="delArticle(scope.row, scope.$index)">移除</el-button>
                    <el-button type="text" @click="handleSee(scope.row, scope.$index)">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
            <!-- 文章 -->
            <template v-if="form.moduleCode === 3 || form.moduleCode === 15 || form.moduleCode === 16">
              <el-row class="operate" style="margin-bottom: 10px;">
                <el-button type="primary" @click="add(1, '添加文章', form.moduleCode)">添加文章</el-button>
              </el-row>
              <p class="tips-text">官网推荐位最多可设置5篇文章，按住内容可上下拖拽设置排序</p>
              <el-table ref="singleTable" :data="form.content" row-key="articleId" style="width: 100%" row-class-name="draggable-btn" >
                <el-table-column prop="title" label="内容标题"></el-table-column>
                <el-table-column label="封面图" width="220px">
                  <template slot-scope="scope">
                    <el-image v-for="item in scope.row.headPicUrlList" style="width: 60px;margin-right: 5px"
                              :src="item" fit="contain"/>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="100px">
                  <template slot-scope="scope">
                    <el-button type="text" @click="delArticle(scope.row, scope.$index)">移除</el-button>
                    <el-button type="text" @click="handleSee(scope.row, scope.$index)">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
            <!-- 管理团队 -->
            <template v-if="form.moduleCode === 7">
              <el-row class="operate" style="margin-bottom: 10px;">
                <el-button type="primary" @click="bindStaff">选择员工</el-button>
              </el-row>
              <el-table :data="form.content" style="width: 100%">
                <el-table-column prop="userName" label="员工姓名"></el-table-column>
                <!-- <el-table-column prop="postName" label="职位" width="140px"></el-table-column> -->
                <!-- <el-table-column prop="userIntroduction" label="介绍"></el-table-column> -->
                <el-table-column label="操作" width="100px">
                  <template slot-scope="scope">
                    <el-button type="text" @click="delArticle(scope.row, scope.$index)">移除</el-button>
                    <el-button type="text" @click="handleSeeManage(scope.row)">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
            <!-- 合作伙伴 -->
            <template v-if="form.moduleCode === 6">
              <p>
                <span class="tips-text">请上传7：3的封面图片</span>
              </p>
              <FileUploadHeader
                v-model="form.fileObjs"
                :limit="9"
                :readOnly="false"
                 accept="image/gif,image/jpg,image/jpeg,image/png"
                 :fixedNumber="[21, 9]"
                 :autoCropWidth="210" :autoCropHeight="90"
                @on-change="handleFileChangeParter"
              ></FileUploadHeader>
            </template>
            <template v-if="form.moduleCode === 13">
              <el-form-item label="组件说明：">
                <div style="color: gray">组织成员组件将展示组织下添加的下属成员信息。</div>
                <el-button type="primary" @click="toGroupMemberPage">添加成员</el-button>
              </el-form-item>
            </template>
          </el-form>
        </div>
      </div>
    </div>
    <!-- 产品，文章，案例列表 -->
    <el-dialog :title="title" :visible.sync="dialogTableVisible" width="80%">
      <!-- <el-button @click="toggleSelection(form.content)">选中第一行</el-button> -->
      <el-table v-if="dialogTableVisible" ref="multipleTable" :data="list" tooltip-effect="dark" @selection-change="handleSelectionChange" multipleTable style="max-height:500px;overflow:auto;">
        <!-- 轮播图绑定产品单选 -->
        <el-table-column  align="center" v-if="targetChoose">
          <template slot-scope="scope">
            <el-radio v-model="radio" @change="radioChange($event, scope.row)" name="radio" :label="scope.row.articleId"><span></span></el-radio>
          </template>
        </el-table-column>
        <el-table-column
          v-else
          type="selection"
          width="55"
          align="center"
        >
        </el-table-column>
        <!-- 多选 -->
        <el-table-column label="内容标题"  prop="title"></el-table-column>
        <el-table-column label="封面图" width="230" prop="title">
          <template slot-scope="scope">
            <el-image v-for="item in scope.row.headPicUrlList" style="width: 60px;margin-right: 5px"
                      :src="item" :preview-src-list="[item]" fit="contain"/>
          </template>
        </el-table-column>
        <el-table-column label="发布时间" width="200" prop="appShowPublishTimeStr"></el-table-column>
      </el-table>
       <pagination
         v-show="queryParams.total>0"
        :total="queryParams.total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="queryArticleList"
      />
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="toggleSelection">设置</el-button> -->
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmArticle">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 选择管理团队 -->
    <el-dialog title="选择员工" :visible.sync="dialogManageVisible">
      <el-table  v-if="dialogManageVisible" ref="multipleTable" :data="list" tooltip-effect="dark" @selection-change="handleSelectionChange" multipleTable style="max-height:500px;overflow:auto;">
        <el-table-column
          type="selection"
          width="55"
          align="center"
        >
        </el-table-column>
        <el-table-column label="员工姓名" prop="userName"></el-table-column>
        <el-table-column label="手机号" prop="phoneNumber"></el-table-column>
        <!-- <el-table-column label="简介" prop="userIntroduction">
        </el-table-column> -->
      </el-table>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="toggleSelection">设置</el-button> -->
        <el-button @click="dialogManageVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmArticle">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 绑定员工 -->
    <el-dialog :title="title" :visible.sync="bindDialogVisible">
      <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
      <el-tree
        class="filter-tree"
        :data="data"
        :props="defaultProps"
        accordion
        :filter-node-method="filterNode"
        @node-click="getCheckedNodes"
        ref="tree"
      ></el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button @click="bindDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="bindDialogVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    <ArticleDetailDialog ref="articleDetailDialogRef"></ArticleDetailDialog>
    <ManageDetailDialog ref="manageDialogRef"></ManageDetailDialog>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import {appInfos, baseList, iconArr, moduleList} from './components/websiteConfig'
import FileUpload from "@/views/crm/components/fileUpload";
import FileUploadHeader from "@/components/CropperFileUpload/CropperFileUpload";
import {
  getWebsiteDetail,
  queryArticleList,
  queryCompanyDetail,
  queryTenantDetail,
  saveWebsite,
  userBusinessCardList
} from "@/api/saas/package";
import {joinGroupList, queryMemberList} from '@/api/system/tenant'
import {getCompanyInfoCount} from '@/api/crm/company'
import phoneHeader from "@/assets/decorate/phone-header.png";
import ArticleDetailDialog from './components/articleDetailDialog'
import ManageDetailDialog from './components/manageDialog'
import Sortable from "sortablejs"

export default {
  name: "Decorate",
  components: {
    FileUpload,
    ArticleDetailDialog,
    ManageDetailDialog,
    FileUploadHeader
  },
  data() {
    return {
      memberToggleNum: 6, // 组织成员模块，需要"展开"按钮的成员数
      tenantType: null, // 1:企业 2:组织 3:专家
      dialogManageVisible: false, // 选择员工
      targetChoose: false, // true: 轮播图选择绑定
      targetChooseIndex: null, // 轮播图绑定产品
      radio: '',
      iconArr,
      defaultProps: {
        children: "children",
        label: "label"
      },
      filterText: "",
      data: [],
      params: {
        pageNo: 1,
        pageSize: 10
      },
      queryParams: { // 查询产品，案例，文章列表
        pageNo: 1,
        pageSize: 10,
        articleType: null,
        status: 1,
        total: 0
      },
      list: [], // 产品，文章，案例列表
      selectItem: [], // 选中的产品，文章，案例
      title: "", // 弹框名称
      dialogTableVisible: false, // 选择员工弹框
      bindDialogVisible: false, // 绑定员工弹框
      form: {},
      phoneHeader,
      setTitle: '', // 右侧设置名称
      logo: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      titleIcon: [],
      appInfos, // app官网默认展示信息
      moduleList,
      baseList,
      startItem: {},
      startIndex: 0,
      endItem: {},
      endIndex: 0
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId,
      tenantId: state => state.user.tenantId
    })
  },
  created() {
    this.tenantType = this.$store.state.user.tenantType
  },
  mounted() {
    this.iconArr.map(item => {
      this.titleIcon.push({
        url: item
      })
    })
    this.getWebsiteDetail()
    this.dragSort()
  },
  methods: {
    dragSort() {
      this.$nextTick(()=> {
        if(!this.$refs.singleTable) return
        const el = this.$refs.singleTable.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
        this.sortable = Sortable.create(el, {
          onUpdate: e => {	//onEnd是结束拖拽时触发，onUpdate是列表内元素顺序更新的时候触发，更多请看文末配置项
            //e.oldIndex为拖动一行原来的位置，e.newIndex为拖动后新的位置
            let oldIndex = e.oldIndex,
                oldData = this.form.content[oldIndex],
                newIndex = e.newIndex
            let oldArr = JSON.parse(JSON.stringify(this.form.content))
            if(oldIndex > newIndex){ // 从下往上拖动
              oldArr.splice(newIndex, 0, oldData)
              oldArr.splice(oldIndex + 1, 1)
            }else { // 从上往下拖动
              oldArr.splice(newIndex+1, 0, oldData)
              oldArr.splice(oldIndex, 1)
            }
            this.$forceUpdate()
            this.form.content = oldArr
          }
        })
      })
    },
    // 轮播图拖动
    dragend() {
      let appInfoCopy = JSON.parse(JSON.stringify(this.form))
      appInfoCopy.content[this.startIndex] = this.endItem
      appInfoCopy.content[this.endIndex] = this.startItem
      this.form = appInfoCopy
      let currentIndex = 0
      this.appInfos.forEach((item, index)=> {
        if(!item.showShadow){
          currentIndex = index
        }
      })
      this.appInfos[currentIndex] = this.form
    },
    dragstart(item, index){
      this.startItem = item
      this.startIndex = index
    },
    // 记录移动过程中信息
    dragenter(item, index) {
      this.endItem = item
      this.endIndex = index
    },
    toggleSelection(rows) {
      console.log('rows--', rows)
      if (rows) {
        rows.forEach(row => {
          this.$nextTick(() => {
            this.$refs.multipleTable.toggleRowSelection(row);
          })
        });
      } else {
        this.$nextTick(() => {
          this.$refs.multipleTable.clearSelection();
        })
      }
    },
    delArticle(row, index) {
      const that = this
      this.$confirm('确认删除该条数据吗？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.form.content.splice(index, 1)
      })
    },
    // 查看文章内容
    handleSee(row, index){
      this.$refs.articleDetailDialogRef.open(row)
    },
    // 查看管理员信息
    handleSeeManage(row) {
      this.$refs.manageDialogRef.open(row)
    },
    // 选中员工节点
    getCheckedNodes(e){
      this.bindDialogVisible = false
      this.form.staffName = e.label
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    //
    bindStaff() {
      this.dialogManageVisible = true;
      this.queryManageList()
    },
    // 轮播图添加图片
    addPic() {
      if(this.form.content.length>= 10) {
        this.msgWarning('最多可添加10张图片')
      }else {
        this.form.content.push({
          fileObjs: [], // 图片数据
          targetType: null, // 不需要跳转可以不传，目标类型 1-文章 2-产品 3-案例
          targetId: null, // 跳转目标id
          picUrl: null,
          name: null, // 需要跳转的名称
          jumpFlag: 0 , // 是或支持跳转 0-不支持 1-支持
        });
      }
    },
    handleCurrentChange(value) {
      this.params.pageNo = value;
    },
    handleSizeChange(value) {
      this.params.pageSize = value;
    },
    add(type, title, moduleCode) {
      this.targetChoose = false // true：绑定产品  false：多选产品
      this.queryParams.pageNo = 1;
      this.queryParams.articleType = type
      this.title = title;
      this.dialogTableVisible = true;
      this.queryParams.tag = null
      if (moduleCode === 15) {
        this.queryParams.tag = '技术'
      } else if (moduleCode === 16) {
        this.queryParams.tag = '招标'
      }
      this.queryArticleList()
      this.$nextTick(() => {
        // this.selectItem = this.form.content
        // this.$refs.multipleTable.toggleRowSelection(this.list[0]);
        // console.log('this.selectItem', this.form ,'this.form.content ', this.form.content )
        // this.$refs.multipleTable.toggleRowSelection(this.selectItem) // 设置默认选中
        // this.selectItem.forEach(row => {
        //   this.$refs.multipleTable.toggleRowSelection(row);
        // })
      })
    },
    // toggleSelection(rows) {
    //   console.log('selectItem', this.selectItem)
    //   // this.selectItem.forEach(row => {
    //     console.log('list0', this.list[0], this.selectItem[0])
    //     this.$refs.multipleTable.toggleRowSelection(this.selectItem[0]);
    //   // });
    // },
    // 轮播图绑定下拉菜单点击
    dropdownClick(e, index) {
      console.log('click-', e)
      this.targetChoose = true
      this.targetChooseIndex = index
      this.queryParams.pageNo = 1;
      this.title = '选择';
      this.radio = this.form.content[index].targetId
      if(e === 'product') {
        this.dialogTableVisible = true;
        this.queryParams.articleType = 3
        this.queryArticleList()
      }else if(e === 'case') {
        this.dialogTableVisible = true;
        this.queryParams.articleType = 2
        this.queryArticleList()
      }else {
        let target = this.form.content[this.targetChooseIndex]
        target.targetType = null // 不需要跳转可以不传，目标类型 1-文章 2-产品 3-案例
        target.targetId = null // 跳转目标id
        target.name = null // 需要跳转的名称
        target.jumpFlag = 0  // 是或支持跳转 0-不支持 1-支持
      }
    },
    // 获取产品，文章，案例列表
    queryArticleList() {
      this.loading = true;
      queryArticleList(Object.assign(this.queryParams))
        .then(response => {
          this.list = response.rows || [];
          this.loading = false;
          this.queryParams.total = response.total;
          // 设置默认选中
          let selectArr = []
          this.form.content.forEach(item => {
            this.list.forEach(listItem => {
              if(item.articleId === listItem.articleId){
                selectArr.push(listItem)
              }
            })
          })
          // 直接用this.form.content里的数据会导致选不中
          setTimeout(()=> {
            this.toggleSelection(selectArr)
          }, 100)
        })
        .catch(error => {
          this.loading = false;
        });
    },
    // 获取管理团队成员
    queryManageList() {
      this.loading = true;
      userBusinessCardList()
        .then(response => {
          this.list = response.data || [];
          this.loading = false;
          // 设置默认选中
          let selectArr = []
          this.form.content.forEach(item => {
            this.list.forEach(listItem => {
              if(item.id === listItem.id){
                selectArr.push(listItem)
              }
            })
          })
          setTimeout(()=> {
            this.toggleSelection(selectArr)
          }, 100)
        })
        .catch(error => {
          this.loading = false;
        });
    },
    handleSelectionChange(e){
      console.log('eee--', e)
      this.selectItem = e
    },
    confirmArticle() {
      if(this.targetChoose){
        let target = this.form.content[this.targetChooseIndex]
        target.targetType = this.selectItem.articleType // 不需要跳转可以不传，目标类型 1-文章 2-产品 3-案例
        target.targetId = this.selectItem.articleId // 跳转目标id
        target.name = this.selectItem.title // 需要跳转的名称
        target.jumpFlag = 1  // 是或支持跳转 0-不支持 1-支持
        target.contentType = this.selectItem.contentType // 图文还是视频
        this.dialogTableVisible = false
      }else {
        if(this.selectItem.length <= 5) {
          this.form.content = this.selectItem
          this.selectItem = []
          this.dialogTableVisible = false // 文章弹框
          this.dialogManageVisible = false // 绑定管理员弹框
        }else {
          this.msgWarning("最多可添加五个");
        }
      }
    },
    // 轮播图绑定产品，案例选中事件
    radioChange(e, value){
      this.selectItem = value
    },
    checkboxChange(e, value){
    },
    addarticle() {},
    addCase() {},
    addProduct() {},
    addManage() {},
    //  下移一位
    goDown(index) {
      let appInfos = JSON.parse(JSON.stringify(this.appInfos))
      let top = appInfos[index];
      let bottom = appInfos[index + 1];
      appInfos[index] = bottom;
      appInfos[index + 1] = top;
      this.appInfos = appInfos
    },
    //  上移一位
    goUp(index) {
      let appInfos = JSON.parse(JSON.stringify(this.appInfos))
      let top = appInfos[index - 1];
      let bottom = appInfos[index];
      appInfos[index] = top;
      appInfos[index - 1] = bottom;
      this.appInfos = appInfos
    },
    // 删除
    goDel(index) {
      this.$confirm("确认删除该模块？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.appInfos.splice(index, 1);
        this.appInfos[index-1].showShadow = false
        this.form = this.appInfos[index-1] // 删除后重新设置当前选中模块
      });
    },
    // 手机端展示当前模块选中
    selectModule(item) {
      this.appInfos.forEach(info => {
        info.showShadow = true;
      });
      this.setTitle = `${item.moduleName}设置`;
      item.showShadow = false;
      this.form = item;
      console.log('appinfos-', this.appInfos)
      this.dragSort()
    },
    // 新增组件
    async addModule(item) {
      this.appInfos.forEach(info => {
        info.showShadow = true;
      });
      item.moduleName = !item.moduleName ? '' : item.moduleName
      this.setTitle = `${item.moduleName}设置`;
      if (item.moduleCode === 17) {
        await queryCompanyDetail({}).then(response => {
          // 企业名称设置
          this.appInfos.push({
            ...item,
            title: "企业名称",
            content: {
              companyName: response.data.fullName,
              companyLogo: response.data.companyLogo
            },
            showShadow: false
          });
        }).catch(error => {
          // 企业名称设置
          this.appInfos.push({...item, title: "企业名称", content: '', showShadow: false});
        });
      } else if (item.moduleCode === 100) {
        // 标题设置
        this.appInfos.push({
          ...item,
          moduleIcon: this.iconArr[0],
          title: "标题",
          content: '',
          showShadow: false
        });
      } else if (item.moduleCode === 101) {
        // 文本设置
        this.appInfos.push({
          ...item,
          //   moduleName: item.name,
          titleShow: ["showTitle", "showSubTitle"],
          title: '标题',
          content: {
            textPosition: 1, // 文本位置 1-左侧对齐 2-水平居中
            mainTitle: '主标题',
            subTitle: '副标题',
            textContent: '内容'
          },
          showShadow: false
        });
      } else if (item.moduleCode === 102) {
        // 图片设置
        this.appInfos.push({
          ...item,
          content:{
            type: 3,
            picStyle: 1,
            picUrlList: []
          },
          moduleIcon: this.iconArr[8],
          showShadow: false,
          fileObjs: []
        });
      } else if (item.moduleCode === 103) {
        // 轮播图设置
        this.appInfos.push({
          ...item,
          content: [
            {
              fileObjs: [], // 图片数据
              targetType: null, // 不需要跳转可以不传，目标类型 1-文章 2-产品 3-案例
              targetId: null, // 跳转目标id
              picUrl: null,
              name: null, // 需要跳转的名称
              jumpFlag: 0 , // 是或支持跳转 0-不支持 1-支持
            }
          ],
          moduleIcon: this.iconArr[0],
          showShadow: false,
          fileObjs: []
        });
      } else if (item.moduleCode === 104) {
        // 视频设置
        this.appInfos.push({
          ...item,
          showShadow: false,
          moduleIcon: this.iconArr[6],
          content:
            {
              videoUrl: '',
              coverPicUrl: '',
              title: ''
            }
          ,
          fileObjs: [],
          title: '视频'
        });
      } else if (item.moduleCode === 1) {
        // 关于我们
        this.appInfos.push({
          ...item,
          moduleIcon: this.iconArr[0],
          title: item.name,
          content: {
            fileObjs: [],
            introduction: '文字介绍',
            picUrl: ''
          },
          showShadow: false
        });
      } else if (item.moduleCode === 3 || item.moduleCode === 15 || item.moduleCode === 16) {
        // 3-企业文章 15-技术文章 16-招标信息
        this.appInfos.push({
          ...item,
          moduleIcon: this.iconArr[0],
          title: item.name,
          content: [], // 文章列表
          showShadow: false
        });
      } else if (item.moduleCode === 4) {
        // 案例
        this.appInfos.push({
          ...item,
          moduleIcon: this.iconArr[0],
          title: item.name,
          content: [], // 文章列表
          showShadow: false
        });
      } else if (item.moduleCode === 2) {
        // 产品
        this.appInfos.push({
          ...item,
          moduleIcon: this.iconArr[0],
          title: item.name,
          content: [], // 文章列表
          showShadow: false
        });
      } else if (item.moduleCode === 5) {
        // 联系我们

        this.appInfos.push({
          ...item,
          moduleIcon: this.iconArr[0],
          title: item.name,
          content: {
            linkPhoneNumber: '',
            linkAddress: ''
          },
          showShadow: false
        });
      } else if (item.moduleCode === 7) {
        // 管理团队
        this.appInfos.push({
          ...item,
          moduleIcon: this.iconArr[0],
          title: item.name,
          content: [], // 管理团队列表
          showShadow: false
        });
      } else if (item.moduleCode === 6) {
        // 合作伙伴
        this.appInfos.push({
          ...item,
          moduleIcon: this.iconArr[0],
          title: item.name,
          content: [],
          fileObjs: [], // 合作伙伴 图片列表
          showShadow: false
        });
      } else if (item.moduleCode === "service") {
        // 咨询
        this.appInfos.push({
          ...item,
          moduleIcon: this.iconArr[0],
          title: item.name,
          staffName: "", // 员工名称
          showShadow: false
        });
      } else if (item.moduleCode === 9) {
        // 入驻组织
        this.appInfos.push({
          ...item,
          moduleIcon: this.iconArr[0],
          title: "标题",
          content: '',
          showShadow: false
        });
        this.queryGroup(this.appInfos.length)
      } else if (item.moduleCode === 10) {
        // 企业分类
        this.appInfos.push({
          ...item,
          moduleIcon: this.iconArr[0],
          title: "标题",
          content: '',
          showShadow: false
        });
        this.queryTags(this.appInfos.length)
      } else if (item.moduleCode === 11) {
        // 图片
        this.appInfos.push({
          ...item,
          title: item.name,
          content:{
            type: 3,
            picStyle: 1,
            picUrlList: []
          },
          moduleIcon: this.iconArr[8],
          showShadow: false,
          fileObjs: []
        });
      }
       else if (item.moduleCode === 12) {
        // 视频
        this.appInfos.push({
          ...item,
          showShadow: false,
          title: item.name,
          moduleIcon: this.iconArr[6],
          content:
            {
              videoUrl: '',
              coverPicUrl: '',
              title: ''
            }
          ,
          fileObjs: [],
        });
      }
      else if (item.moduleCode === 13) {
        // 组织成员 异步会导致新增的时候右侧获取的不是当前增加的组织模块
        await queryMemberList({pageNum: 1, pageSize: 100, groupId: this.tenantId})
          .then(response => {
            this.appInfos.push({
              ...item,
              showShadow: false,
              openFlag: false,
              title: item.name,
              moduleIcon: this.iconArr[2],
              content: response
            })
          })
      } else if (item.moduleCode === 14) {
        await getCompanyInfoCount({tenantId: this.tenantId, typeList: [1, 2, 3]}).then(response => {
          // 知识产权设置
          this.appInfos.push({
            ...item,
            title: "知识产权",
            moduleIcon: this.iconArr[0],
            content: {
              tradeMarkCount: response.data.tradeMarkCount,
              patentCount: response.data.patentCount,
              certificateCount: response.data.certificateCount
            },
            showShadow: false
          });
        }).catch(error => {
          // 企业名称设置
          this.appInfos.push({...item, title: "知识产权", content: {}, showShadow: false});
        });
      }
      let length = this.appInfos.length;
      this.form = this.appInfos[length - 1]; // 设置编辑信息
      this.$nextTick(function(){
        var div = document.getElementById('dialogue_box');
        div.scrollTop = div.scrollHeight;
      })
    },
    // 查询已加入等组织
    queryGroup(index){
      joinGroupList().then(res => {
        this.appInfos[index-1].content = res.data
      })
    },
    // 查询分类
    queryTags(index) {
      queryTenantDetail({
        tenantId: this.$store.state.user.tenantId
      })
        .then(response => {
          this.appInfos[index-1].content = response.data.tagList
        })
        .catch(error => {
          this.loading = false;
        });
    },
    // title图标
    iconSelect(icon) {
      this.form.moduleIcon = icon.url;
    },
    handleFileChange(fileObjs, type) {
      if(type === 'pic') {
        if(fileObjs.length === 0){
          this.form.content.fileObjs = [];
          this.form.content.coverPicUrl = ''
        }else {
          this.form.content.fileObjs = fileObjs;
          this.form.content.coverPicUrl = fileObjs[0].url
        }
      }else {
        if(fileObjs.length === 0) {
          this.form.content.videoFileObjs = [];
          this.form.content.videoUrl = ''
        }else {
          this.form.content.videoFileObjs = fileObjs;
          this.form.content.videoUrl = fileObjs[0].url
        }
      }
    },
    // 关于我们文件上传
    handleFileChangeAbout(fileObjs) {
      this.form.content.fileObjs = fileObjs
      this.form.content.picUrl = fileObjs.length > 0 ? fileObjs[0].url : ''
    },
    // 图片模块文件上传
    handleFileChangePic(fileObjs) {
      this.form.content.fileObjs = fileObjs
      this.form.content.picUrlList = []
      fileObjs.map(file => {
        this.form.content.picUrlList.push(file.url)
      })
    },
    // 绑定轮播图图片设置
    handleFileChangeCarousel(fileObjs, index) {
      if(fileObjs.length > 0) {
        this.form.content[index].fileObjs = fileObjs
        this.form.content[index].picUrl = fileObjs[0].url
      }else {
        this.form.content[index].fileObjs = []
        this.form.content[index].picUrl = ''
      }
    },
    handleFileChangeParter(fileObjs) {
      this.form.content = []
      this.form.fileObjs = fileObjs
      console.log('fileobjs', fileObjs)
      fileObjs.map(item => {
        this.form.content.push(
          item.url
        )
      })
    },
    // 保存官网配置
    handleSave() {
      let flag = false, // 轮播图是否都上传了图片
          videoFlag = false, // 视频是否上传视频链接
          videoCoverFlag = false, // 视频模块封面图必填校验
          phoneNumberFlag = false // 联系我们手机电话必填
      this.appInfos.map(item => {
        if(item.moduleCode === 103){
          item.content.map(i => {
            if(!i.picUrl){
              flag = true
            }
          })
        }
        // 视频文件模块视频文件必填
        if((item.moduleCode === 104 || item.moduleCode === 12)  && !item.content.videoUrl) {
            videoFlag = true
        }

        // 视频文件模块视频封面必填
        if((item.moduleCode === 104 || item.moduleCode === 12)  && !item.content.coverPicUrl) {
            videoCoverFlag = true
        }

        // 联系我们手机电话必填
        if(item.moduleCode === 5  && !item.content.linkPhoneNumber) {
            phoneNumberFlag = true
        }
      })
      if(flag){
        this.msgWarning('轮播图图片不可为空！')
        return
      }
      if(videoFlag){
        this.msgWarning('视频文件不可为空！')
        return
      }
      if(videoCoverFlag){
        this.msgWarning('视频封面不可为空！')
        return
      }
      if(phoneNumberFlag){
        this.msgWarning('联系我们模块联系电话不可为空！')
        return
      }
      let param = JSON.parse(JSON.stringify(this.appInfos))
      param.forEach(item => {
        // 这几个模块后台都会重新查，不用存到数据库中 9-入驻组织 13-组织成员
        if (item.moduleCode === 9 || item.moduleCode === 13) {
          item.content = null
        }
      })
      saveWebsite(param).then(response => {
          this.msgSuccess("官网配置保存成功");
        })
        .catch(error => {
          this.loading = false;
        });
    },
    // 获取官网配置
    getWebsiteDetail() {
      getWebsiteDetail().then(response => {
          if(response.data.length > 0){
              response.data.map(item => {
                if (item.moduleCode === 13) {
                  item.openFlag = false
                } else if (item.moduleCode === 102 || item.moduleCode === 11) {
                  if (!item.content.picStyle) {
                    item.content.picStyle = 1 // 1-横版 2-竖版
                  }
                }
                item.showShadow = true
              })
              this.appInfos = response.data
          }
          this.form = this.appInfos[0];
          this.setTitle = `${this.form.moduleName}设置`;
          this.appInfos[0].showShadow = false;
        })
        .catch(error => {
          this.loading = false;
        });
    },
    toGroupMemberPage() {
      window.open("/package/manageMember", '_blank');
    },
    handleMemberToggle(item, value) {
      item.openFlag = (value === 1)
    }
  }
};
</script>

<style lang='scss' scoped>
::v-deep .draggable-btn{
  cursor: all-scroll;
}
.content-box{
  position: relative;
  .home-btn{
    position: absolute;
    right: 24px;
    top: 33px;
    padding: 3px 7px;
  }
}

.w-main {
  height: 100%;
  .flex {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
  }
  .companyName {
    line-height: 36px;
    vertical-align: middle;
    color: #5a5a5a;
    margin-left: 10px;
    display: inline-block;
    margin-top: -30px;
    max-width: 251px;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
  }
  .company-gsxx {
    width: 15px;
    height: 15px;
    line-height: 36px;
    margin-top: -32px;
    vertical-align: middle;
    margin-left: 5px;
  }
  .article-only-title {
    font-size: 14px;
    width: 220px;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    display: inline-block;
  }
  .knowledge-info {
    text-align: center;
    display: inline-block;
    width: 109px;
  }
  .knowledge-icon {
    width: 40px;
    height: 40px;
  }
  .info-count {
    position: relative;
    top: -55px;
    left: 28px;
    color: #00a0e9;
  }
  .info-name {
    font-size: 14px;
    margin-bottom: 13px;
  }
  .w-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 64px;
    color: #fff;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    padding: 0 30px;
    align-content: left;
    z-index: 9;
    .info {
      flex: 1;
      font-size: 20px;
      color: rgba(0, 0, 0, 0.65);
      justify-content: left;
      align-items: center;
      display: flex;
    }
    .operate {
      flex: 1;
      text-align: right;
    }
  }
  .w-content {
    position: fixed;
    left: 0;
    right: 0;
    top: 64px;
    bottom: 0;
    width: 100%;
    display: flex;
    z-index: 8;
    .w-left {
      width: 345px;
      height: 100%;
      background-color: #fff;
      box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2);
      overflow: auto;
      .w-title {
        height: 40px;
        line-height: 40px;
        text-align: center;
        border-bottom: 1px solid #e1e1e1;
        margin: 0;
      }
      .w-module {
        overflow: hidden;
      }
      .module {
        float: left;
        width: 110px;
        height: 110px;
        text-align: center;
        border-right: 1px solid #e1e1e1;
        border-bottom: 1px solid #e1e1e1;
        cursor: pointer;
        color: #666;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        &:nth-child(3n) {
          border-right: none;
        }
        &:hover {
          // color: #2d7ee8;
          background: rgb(236, 243, 253);
          opacity: 0.8;
        }
        .module-name {
          font-size: 14px;
          margin-top: 4px;
        }
        .module-cion {
          display: block;
          margin-top: 20px;
          margin-bottom: 10px;
          font-size: 32px;
        }
      }
    }
    .w-right {
      width: 600px;
      height: 100%;
      overflow-y: auto;
      background-color: #fff;
      .set-title {
        height: 50px;
        padding-left: 20px;
        color: #2e2e2e;
        font-size: 16px;
        line-height: 50px;
        text-align: center;
        border-bottom: 1px solid #ddd;
        margin: 0;
        font-weight: 550;
      }
    }
    .w-center {
      flex: 1;
      overflow-y: auto;
      background-color: #f0f0f0;
      .phone-box-w {
        width: 375px;
        margin: 100px auto;
        border: 1px solid #c1cddb;
        background-color: #fff;
        .module-item {
          position: relative;
          .shadow {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 999;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
          }
          &:hover {
            .ope-btns {
              display: block;
            }
          }
          .ope-btns {
            position: absolute;
            top: 0;
            right: -40px;
            display: none;
            width: 40px;
            color: #fff;
            text-align: center;
            background-color: silver;
            border-radius: 2px;
            i {
              display: block;
              padding: 12px;
              font-size: 16px;
              cursor: pointer;
            }
          }
          .website {
            width: 100%;
            padding: 0 15px 0;
            overflow: hidden;
            &.img-website,
            &.slide-website {
              padding: 0;

              > div {
                width: 100%;
              }
              .type-1 {
                height: 134px;
                .img{
                display: inline-block;
                height: 100%;
                width: 100%;
                background: url(../../../../assets/decorate/single-img-bg.png)
                    no-repeat center;
                  background-size: 100%;
              }
              }
              .type-2 {
                height: 348px;
              }
              .type-3 {
                height: 531px;
              }
            }
            &.video-website,
            &.about-website {
              padding: 15px;
            }
            .text-box {
              width: 100%;
              padding: 15px;
              background: #fff;
              border-radius: 4px;
              box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
              line-height: 1.5;
              &.article-box {
                position: relative;
                justify-content: left;
                align-items: flex-start;
                .header-img-box {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                }
                .content-box {
                  //margin-left: 15px;
                  .article-title {
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.65);
                    white-space: nowrap;
                    word-break: break-all;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    font-weight: 550;
                    margin: 0;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    width: 200px;
                  }
                  .article-info {
                    font-size: 12px;
                    color: #999;
                  }
                }
              }
              .h3 {
                color: #333;
                font-weight: 700;
                font-size: 15px;
                margin: 0;
              }
              .h4 {
                margin: 0;
                color: #666;
                word-break: break-all;
                font-weight: 400;
                font-size: 14px;
              }
              .p {
                margin: 0;
                color: #666;
                word-break: break-all;
                font-size: 14px;
              }
            }
            .img-box {
              overflow: hidden;
              width: 2000%;
              //   padding: 15px;
              .single-img {
                height: 528px;
                background: url(../../../../assets/decorate/single-img-bg.png)
                  no-repeat center;
                background-size: 100% 100%;
              }
              .slide-img {
                display: flex;
                width: 20000px;
                overflow: hidden;
                &.pic {
                  padding: 15px;
                }
                .img {
                  display: inline-block;
                  width: 220px;
                  height: 127px;
                  margin-right: 15px;
                  border-radius: 4px;
                  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
                  background: url(../../../../assets/decorate/single-img-bg.png)
                    no-repeat center;
                  background-size: 100%;
                }
                &.horizontal {
                  .img {
                    width: 160px;
                    height: 100px;
                  }
                }
                &.vertical {
                  .img {
                    width: 105px;
                    height: 150px;
                  }
                }
              }
              .three-img {
                position: relative;
                display: flex;
                justify-content: space-between;
                .img {
                  display: inline-block;
                  width: 118px;
                  height: 68px;
                  background: url(../../../../assets/decorate/single-img-bg.png)
                    no-repeat center;
                  background-size: 100%;
                  &:first-child {
                    width: 210px;
                    height: 150px;
                  }
                  &:last-child {
                    position: absolute;
                    right: 15px;
                    bottom: 15px;
                  }
                }
              }
              .four-img {
                position: relative;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                .img {
                  display: inline-block;
                  width: 163px;
                  height: 127px;
                  background: url(../../../../assets/decorate/single-img-bg.png)
                    no-repeat center;
                  background-size: 100%;
                  margin-bottom: 15px;
                }
              }
              //   .three-img {
              //     height: 528px;
              //     background: url(@/assets/decorate/single-img-bg.png)
              //       no-repeat center;
              //     background-size: 100% 100%;
              //   }
            }
            .video-box {
              overflow: hidden;
              background: #fff;
              border-radius: 4px;
              box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
              .video-bg{
                &:after {
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  display: block;
                  width: 60px;
                  height: 60px;
                  background: url(../../../../assets/decorate/video-bg.png)
                    no-repeat 50% / contain;
                  -webkit-transform: translate(-50%, -50%);
                  -ms-transform: translate(-50%, -50%);
                  transform: translate(-50%, -50%);
                  content: "";
                }
              }
              .video {
                position: relative;
                height: 200px;
                background: url(../../../../assets/decorate/single-img-bg.png)
                  no-repeat center;
                background-size: 100%;
                &.none-video{
                  &:after{
                    background: none;
                  }
                }
                &:after {
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  display: block;
                  width: 60px;
                  height: 60px;
                  background: url(../../../../assets/decorate/video-bg.png)
                    no-repeat 50% / contain;
                  -webkit-transform: translate(-50%, -50%);
                  -ms-transform: translate(-50%, -50%);
                  transform: translate(-50%, -50%);
                  content: "";
                }
              }
              .p {
                display: block;
                padding: 15px;
                margin: 0;
                color: #333;
                font-weight: 700;
                font-size: 15px;
              }
            }
          }
        }
        .module-title {
          display: flex;
          align-items: center;
          line-height: 70px;
          &.items-start {
            line-height: 1.5;
            margin-bottom: 20px;
          }
          .title-icon {
            display: block;
            width: 24px;
            height: 24px;
          }
          .title-name {
            padding-left: 5px;
            font-size: 16px;
          }
        }
      }
    }
  }
  .image-slot {
    background: url(../../../../assets/decorate/default-header.png) no-repeat center;
    background-size: 100% 100%;
  }
  .form-box {
    padding: 24px;
  }
  .el-form-item {
    margin-bottom: 15px;
  }
  ::v-deep.el-form-item__label {
    color: #333;
    font-weight: normal;
  }
  .title-icon-box {
    display: flex;
    flex-wrap: wrap;
  }
  .icon-box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    margin: 0 20px 16px 0;
    text-align: center;
    cursor: pointer;
  }
  .icon-box.current {
    background: url(../../../../assets/decorate/current-icon.png) no-repeat top;
    background-size: 40px 40px;
  }
  .img-content {
    padding: 15px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
    .img-list {
      overflow: hidden;
      // display: flex;
      // flex-wrap: wrap;
      // justify-content: space-between;
      .img-bg {
        float: left;
        margin-right: 15px;
        margin-bottom: 10px;
        background: url(../../../../assets/decorate/img-bg.png) no-repeat center;
        background-size: 100%;
        width: 94px;
        height: 45px;
        &:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }
  .contact-content {
    padding: 15px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
    overflow: hidden;
    margin-bottom: 10px;
    display: flex;
    margin-bottom: 10px;
    justify-content: center;
    align-items: center;
    .label-icon {
      width: 50px;
      height: 50px;
      font-size: 30px;
      color: #999;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .label-content {
      border-left: 1px solid #e1e1e1;
      padding-left: 10px;
      min-height: 50px;
      flex: 1;
      .label-title {
        color: #999;
        font-size: 12px;
        margin-bottom: 1em;
        margin-top: 5px;
      }
      .label-info {
        word-break: break-all;
        color: rgba(0, 0, 0, 0.65);
        font-size: 14px;
      }
    }
  }
  .manage-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .manage-list {
      position: relative;
      width: 163px;
      background: #fff;
      border-radius: 4px;
      box-shadow: 0 2px 5px 2px rgba(0, 0, 0, 0.1);
      margin-bottom: 15px;
      margin-top: 40px;
      .header-bg {
        position: absolute;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        background: url(../../../../assets/decorate/img-bg.png) no-repeat center;
        background-size: 100%;
        left: 41px;
        top: -40px;
        overflow: hidden;
      }
      .text {
        padding: 56px 15px 15px;
        text-align: center;
      }
      .title {
        color: #333;
        font-weight: 700;
        font-size: 15px;
        line-height: 1.8;
      }
      .sub-title {
        color: #afafaf;
        font-size: 12px;
        line-height: 20px;
        height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .intro {
        color: #666;
        font-size: 14px;
        line-height: 1.8;
        word-wrap: break-word;
        word-break: break-all;
      }
    }
  }
  .no-data {
    height: 210px;
    background-color: #ddd;
    color: #fff;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .carousel-box {
    position: relative;
    display: flex;
    margin-bottom: 12px;
    padding: 16px;
    color: #666;
    background-color: #f5f5f5;
    cursor: all-scroll;
    .close-icon{
      display: none;
      position: absolute;
      top: -5px;
      right: 0;
      color: #ff6767;
      cursor: pointer;
    }
    &:hover{
      .close-icon{
        display: block;
      }
    }
    .jump-info {
      font-size: 14px;
      font-weight: normal;
      color: #666;
      margin-left: 8px;
    }
    .el-dropdown-link {
      font-size: 14px;
      cursor: pointer;
      color: #409eff;
    }
    .el-icon-arrow-down {
      font-size: 12px;
    }
  }
  .tip {
    color: #999;
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 1em;
  }
}
.service-website{
}
::v-deep.el-icon-picture-outline:before{
  content: ''
}
.default-header{
  display: inline-block;
  width: 80px;
  height: 80px;
  background:#eee;
  border-radius: 50%;
  background: url(../../../../assets/decorate/default-header.png) no-repeat center;
  background-size: 100%;
}

.groupMemberContent {
  border-left: 1px solid #ededed;
  border-top: 1px solid #ededed;
}

.groupMember {
  width: 114px;
  height: 114px;
  border-right: 1px solid #ededed;
  border-bottom: 1px solid #ededed;
  display: inline-block;
}
.groupMemberLogo {
  width: 45px;
  height: 45px;
  margin-left: 32px;
  margin-top: 13px;
  border-radius: 50%;
}
.groupMemberName {
  margin-top: 5px;
  padding: 5px;
  text-align: center;
  font-size: 14px;
  height: 38px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.memberToggle {
  color: gray;
  margin-top: 5px;
  text-align: center;
  cursor: pointer;
}
</style>
